import * as React from "react";
import {
  Alert,
  AlertTitle,
  Avatar,
  Box,
  Button,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";

export default function ViewOnlyModal({ cardData, onClose }) {
  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${cardData?.color} 0%, ${cardData?.color}dd 100%)`,
          p: 4,
          position: "relative",
          color: "white",
          borderRadius: "20px 20px 0 0",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            color: "white",
            backgroundColor: "rgba(255,255,255,0.2)",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.3)" },
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Avatar
            sx={{
              width: 64,
              height: 64,
              fontSize: "2rem",
              backgroundColor: "rgba(255,255,255,0.2)",
              border: "3px solid rgba(255,255,255,0.3)",
            }}
          >
            {cardData?.icon}
          </Avatar>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
              {cardData?.title} Bills
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              View bills uploaded by tenant
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ p: 4 }}>
        <Alert
          severity="info"
          icon={<LockIcon />}
          sx={{
            borderRadius: 3,
            mb: 3,
            backgroundColor: cardData?.bgColor,
            border: `1px solid ${cardData?.color}40`,
            "& .MuiAlert-icon": { color: cardData?.color },
          }}
        >
          <AlertTitle sx={{ fontWeight: 700, color: "#0f172a" }}>View-Only Access</AlertTitle>
          <Typography variant="body2" sx={{ color: "#475569" }}>
            The tenant has permission to upload {cardData?.title?.toLowerCase()} bills. You can view
            uploaded bills here but cannot upload new ones.
          </Typography>
        </Alert>

        <Paper
          sx={{
            p: 4,
            borderRadius: 3,
            backgroundColor: "#f8fafc",
            border: "2px dashed #cbd5e1",
            textAlign: "center",
          }}
        >
          <VisibilityIcon sx={{ fontSize: 64, color: "#94a3b8", mb: 2 }} />
          <Typography variant="h6" sx={{ color: "#475569", fontWeight: 600, mb: 1 }}>
            No Bills to Display
          </Typography>
          <Typography variant="body2" sx={{ color: "#64748b" }}>
            Bills uploaded by tenant will appear here for review.
          </Typography>
        </Paper>

        <Button
          fullWidth
          variant="outlined"
          onClick={onClose}
          sx={{
            mt: 3,
            py: 1.5,
            borderRadius: 3,
            borderColor: "#e2e8f0",
            color: "#64748b",
            fontWeight: 600,
            textTransform: "none",
            "&:hover": { borderColor: "#cbd5e1", backgroundColor: "#f8fafc" },
          }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
}